import React, { useContext, useState } from 'react'
import { ChevronDownIcon, PlusIcon } from '@heroicons/react/outline'
import useOnclickOutside from 'react-cool-onclickoutside'
import clsx from 'clsx'

import AuthContext from '../../context/AuthContext'
import CreateCompanyDialog from './CreateCompanyDialog'
import useCreateCompany from '../../hooks/mutations/useCreateCompany'
import { Badge } from '../../@/components/ui/badge'

const CompanyButton = () => {
	const authContext = useContext(AuthContext)
	const [isOpen, setIsOpen] = useState(false)
	const createCompanyHook = useCreateCompany()

	const ref = useOnclickOutside(() => {
		setIsOpen(false)
	})

	return (
		<div className="relative" ref={ref}>
			<button className="font-bold md:text-lg flex text-left" onClick={() => setIsOpen(!isOpen)}>
				<span className="line-clamp-1">{authContext.company?.name}</span>{' '}
				<ChevronDownIcon className={'ml-2 w-5 place-self-center flex-none'} />
			</button>
			<div
				className={clsx('z-10 w-64 bg-white rounded divide-y divide-gray-100 shadow-sm absolute left-0 top-8', {
					hidden: !isOpen,
				})}
			>
				<ul className="py-1 text-sm text-gray-700 dark:text-gray-200">
					{authContext.companies.map(company => (
						<li key={company.id}>
							<button
								onClick={() => {
									authContext.setCompany(company)
									setIsOpen(false)
								}}
								className={clsx(
									'flex w-full justify-between gap-2 text-left py-2 px-4 hover:bg-gray-100',
									{
										'bg-gray-100 border-r-2 border-hitemup-green-300':
											company.id === authContext.company?.id,
									},
								)}
							>
								<p className="text-sm truncate min-w-0 flex-1">{company.name}</p>
								<div className="flex items-center shrink-0">
									{company.personalAccount && <Badge variant="outline">Personal</Badge>}
								</div>
							</button>
						</li>
					))}
					<li>
						<button
							onClick={createCompanyHook.toggleCreateCompanyDialog}
							className="flex w-full text-left py-2 px-4 hover:bg-gray-100 border-t border-gray-100"
						>
							<PlusIcon className="w-4 mr-2" /> Add Workspace
						</button>
					</li>
				</ul>
			</div>
			<CreateCompanyDialog {...createCompanyHook} />
		</div>
	)
}

export default CompanyButton
